/*
	Validates for are all weekDays are in dateInterval.
	Returns warning string if not valid, empty string if valid and undefined if validation wasn't executed.
	Validation will not execute if weekDays is 127(all week) or dateInterval is more than 7 days.
*/

import moment from 'moment'
import get from 'lodash/get'
import difference from 'lodash/difference'
import { parseWeekDaysNum } from 'components/forms/WeekdayPicker/WeekdayPicker'

/* eslint-disable consistent-return */
export default t => ({ dateInterval = {}, weekDays }) => {
	const { from, to } = dateInterval
	if(!from || !to || weekDays === 127) {
		return ''
	}
	if(weekDays === 0 || weekDays === null) {
		return t('validators.not_work_without_weekdays')
	}
	const momentFrom = moment(from).startOf('day')
	const momentTo = moment(to).endOf('day')
	const periodDays = momentTo.diff(momentFrom, 'days')
	if(periodDays < 7) {
		const weekDaysPeriod = []
		const weekDayFrom = momentFrom.isoWeekday() - 1 // 0=Monday..6=Sunday, aligned with selectedWeekDays
		const selectedWeekDays = parseWeekDaysNum(weekDays, t).map(item => Math.log2(get(item, 'value'))) // Arr of indexes of week days starting from Monday as 0
		for(let i = 0; i < periodDays; i++) {
			weekDaysPeriod.push((weekDayFrom + i) % 7)
		}
		const excludedWeekDays = difference(selectedWeekDays, weekDaysPeriod) // check if weekDays has values that are not included in dateInterval
		const warning = excludedWeekDays.length ? t('validators.weekdays_not_in_period') : ''
		return warning
	}
	return ''
}
/* eslint-enable consistent-return */
